import { mode_edit, mode_view } from '../../../../../../views/my-store/google-profile';

export default {
  title: 'Google-profil',
  sections: {
    current_profile: {
      [mode_view]: 'Forbundet profil',
      [mode_edit]: 'Skift forbundet profil',
    },
  },
  form: {
    google_places_id: {
      label: 'Navn på Google Maps',
    },
    address: {
      label: 'Adresse',
    },
    rating: {
      label: 'Bedømmelse',
    },
    opening_hours: {
      label: 'Åbningstider',
    },
    phone_number: {
      label: 'Telefonnummer',
    },
    pictures: {
      label: 'Billeder',
    },
  },
  labels: {
    no_place_connected: 'Denne restaurant har ingen forbundet Google-profil',
    fields_to_sync: 'Info, der skal synkroniseres fra {{name}}',
  },
  buttons: {
    save: 'Gem',
    change: 'Skift',
    cancel: 'Annuller',
  },
  toasts: {
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
  },
};
